import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';

const ContactFormSubmission = () => {
  const sendEmail = async (values, resetForm) => {
    try {
      const result = await emailjs.sendForm(
        'service_yipk4xg', // YOUR_SERVICE_ID
        'template_71bgc2q', // YOUR_TEMPLATE_ID
        values,
        'cwf8kROl5o3__96Ti' // YOUR_PUBLIC_KEY
      );
      
      if (result.text === 'OK') {
        Swal.fire({
          titleText: 'Success!',
          text: 'Your message has been sent successfully.',
          icon: 'success',
        });
        resetForm();
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      Swal.fire({
        titleText: 'Error',
        text: 'Your message could not be sent. Please try again later.',
        icon: 'error',
      });
    }
  };

  return sendEmail;
};

export default ContactFormSubmission;
